export default __webpack_public_path__ + "static/media/On the way.4fd28604.jpg";